import Service from './Service'
import moment from 'moment'

class Customers extends Service {
  /** @type {array} */
  cachedGroups

  /** @type {moment} */
  groupCacheTime

  getGroups () {
    if (this.cachedGroups &&
      this.groupCacheTime && moment().diff(this.groupCacheTime, 'seconds') < this.cacheTimeNormal
    ) {
      return Promise.resolve(this.cachedGroups)
    }

    let params = {}
    params.request = 'getCustomerGroups'

    return this.fetchAllRecords('', params)
      .then(groups => {
        this.cachedGroups = groups
        this.groupCacheTime = moment()
        return groups
      })
      .catch(response => this.handleErrorResponse(response))
  }
}
export default Customers



// WEBPACK FOOTER //
// ./src/api/Service/Customers.js